<template>
  <svg width="6.438" height="32">
    <path d="M5.5 19.132a8.717 9.999 0 0 0 0-6.253L2.14 1.166A.84.963 0 0 0 .5 1.48v29.043a.845.969 0 0 0 1.647.313z" fill="#F7FCFF" stroke="currentColor"/>
  </svg>
</template>
